/**
 * contractBonusStack — 28/09/2026 (demande user : « limiter les bonus pour
 * que la marge ne dépasse pas 65 % »).
 *
 * Pile de bonus PAR CONTRAT (dépôts × spécialité × compétence × responsable
 * de site × boom sectoriel). Chaque bonus garde son effet individuel mais le
 * PRODUIT est plafonné à ×1,35 : avant, un contrat parfaitement optimisé
 * pouvait dépasser ×1,9 et nourrir une croissance exponentielle.
 */
import { getDepotContractMultiplier } from '../../data/depotEconomics';
import { getDriverSpecialties } from '../../utils/driverSpecialties';
import { getManagerRevenueMultiplier } from '../../utils/managerBonuses';

export const CONTRACT_BONUS_STACK_CAP = 1.35;
export const SPECIALTY_MATCH_BONUS = 0.15;
export const COMPETENCE_BONUS_PER_LEVEL = 0.03;

export function driverMatchesContractCategory(driver, category) {
  if (!driver || !category) return false;
  const specs = getDriverSpecialties(driver);
  const has = (s) => specs.includes(s);
  return specs.includes(category)
    || (category === 'Messagerie / Colis' && has('Messagerie/Colis'))
    || (category === 'BTP / Matériaux' && has('BTP/Matériaux/Engins TP'))
    || (category === 'Spécialisé' && has('ADR/Produits sensibles'))
    || (category === 'Export UE' && (has('Export UE') || has('Longue distance')));
}

/** Produit brut (non plafonné) de la pile de bonus d'un contrat. */
export function computeRawContractBonusMultiplier(state, contract, vehicle, driver) {
  let mult = 1;
  const distanceKm = typeof contract.distanceKm === 'number' ? contract.distanceKm : 100;
  mult *= getDepotContractMultiplier(state.ownedDepots || [], distanceKm);
  if (driver) {
    if (driverMatchesContractCategory(driver, contract.category)) mult *= (1 + SPECIALTY_MATCH_BONUS);
    mult *= (1 + ((driver.competence || 2) - 2) * COMPETENCE_BONUS_PER_LEVEL);
  }
  mult *= getManagerRevenueMultiplier(contract, vehicle, state.ownedDepots, state.hiredDepotManagers);
  const boom = state.marketBoom;
  if (boom && boom.endDay > (state.totalDays || 0)) {
    const sector = (contract.sector || contract.category || '').toLowerCase();
    const theme = (boom.theme || '').toLowerCase();
    if (sector.includes(theme) || theme.includes(sector)) mult *= (1 + (boom.revenueBoost || 0.20));
  }
  return mult;
}

/** Pile de bonus plafonnée à ×CONTRACT_BONUS_STACK_CAP (les malus < 1 passent tels quels). */
export function computeContractBonusMultiplier(state, contract, vehicle, driver) {
  return Math.min(CONTRACT_BONUS_STACK_CAP, computeRawContractBonusMultiplier(state, contract, vehicle, driver));
}
